import { ApiClient as CommonApiClient } from '../../common/helpers/api-client/ApiClient'

export class ApiClient extends CommonApiClient {
  static getSignerStepOneUrl (application) {
    return this.getUrl(`application/step-one?id=${application.id}&access-token=${this.getAccessToken()}`)
  }

  static getSignerStepTwoUrl (application) {
    return this.getUrl(`application/step-two?id=${application.id}&access-token=${this.getAccessToken()}`)
  }

  static getGuardScreenUrl () {
    return this.getUrl('guard', true)
  }

  static getAccountUrl () {
    return this.getUrl('profile/account', true)
  }
}
